import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
// import { resources as AcademicYears } from "../Sessions/AcademicYears";
import { resources as Directions } from "./Directions";
import { resources as ProfessionalDirections } from "./ProfessionalDirections";
import { resources as StructuralUnits } from "./StructuralUnits";
import { resources as Departments } from "./Departments";
import { resources as HealthInsurances } from "./HealthInsurances";
import { resources as EmployeeTitles } from "./ScientificDegree";
import { resources as EmployeePositions } from "./Positions";
import { resources as Employees } from "./Employees";
import { resources as Buildings } from "./Buildings";
import { resources as Rooms } from "./Rooms";
import { resources as GoogleCourses } from "./GoogleCourses";
import { resources as TechnicalEquipment } from "./TechnicalEquipment";
import { resources as Structure } from "./Structure";
import { resources as Wards } from "./Wards";
import { resources as Clinics } from "./Clinic";
import { resources as Hospitalities } from "./Hospitality";

//permissions
export const resources = {
  isMenu: true,
  icon: <AccountTreeOutlinedIcon />,
  name: "Администрация",
  title: "Администрация",
  subMenu: [
    // AcademicYears,
    Directions,
    ProfessionalDirections,
    StructuralUnits,
    Departments,
    Employees,
    HealthInsurances,
    EmployeeTitles,
    EmployeePositions,
    Buildings,
    Rooms,
    GoogleCourses,
    Wards,
    Clinics,
    Hospitalities,
    TechnicalEquipment,
    Structure,
  ],
};
